export default "__VITE_ASSET__B1JPxi6I__"